export enum MediaFileTypeGroupEnum {
  Video = "video",
  Image = "image",
  Font = "font",
}

export interface IMediaFileMetadata {
  width: number;
  height: number;
  imageBlurhash?: string;
}

export interface IMediaFile {
  _id: string;
  type: string;
  typeGroup: MediaFileTypeGroupEnum;
  archived: boolean;
  folder: string | null;
  folderId: string | null;
  orgId: string;
  size: string;
  title: string;
  updatedAt: string;
  createdAt: string;
  url: string;
  contentHash?: string;
  metadata?: Partial<IMediaFileMetadata>;
}

export enum MediaFolderPermEnum {
  Owner = "owner",
  Editor = "editor",
}

export interface IMediaFolderUser {
  id: string;
  type: MediaFolderPermEnum;
}

export interface IMediaFolder {
  _id: string;
  archived: boolean;
  createdAt: string;
  orgId: string;
  title: string;
  updatedAt: string;
  parentId?: string | null;
  users?: IMediaFolderUser[] | null;
  openAccess: boolean;
}

export interface IMediaUploadData {
  title: string;
  type: string;
  typeGroup: string;
  size: number;
  url: string;
  contentHash?: string;
  folderId?: null | string;

  signal?: AbortSignal;
  metadata?: Partial<IMediaFileMetadata>;
  optimizeVideoEnabled?: boolean;
}

export interface IMediaUploadResponse extends IMediaFile {}
